import { render, staticRenderFns } from "./OngoingEmpty.vue?vue&type=template&id=273f3794&scoped=true&lang=pug&"
import script from "./OngoingEmpty.vue?vue&type=script&lang=js&"
export * from "./OngoingEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273f3794",
  null
  
)

/* custom blocks */
import block0 from "./OngoingEmpty.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
